import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function noWhitespace(): ValidatorFn {
  return (abstractControl: AbstractControl): ValidationErrors | null => {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const { value } = abstractControl;

    // To support the p-autocomplete data model, which can be an object
    if (value != null && typeof value !== 'string') {
      return null;
    }

    const stringValue = (abstractControl.value as string) || '';
    const isValid = stringValue.indexOf(' ') < 0;

    return isValid ? null : { whitespace: true };
  };
}
